import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((_theme) => ({
  check: {
    backgroundColor: '#2989ff',
    borderRadius: '50%',
    color: '#ffffff',
    width: 24,
    height: 24,
    padding: 2,
  },
  x: {
    backgroundColor: '#e34242',
    borderRadius: '50%',
    color: '#ffffff',
    width: 24,
    height: 24,
    padding: 2,
  },
  link: {
    backgroundColor: '#706e6b',
    borderRadius: '50%',
    color: '#ffffff',
    width: 24,
    height: 24,
    padding: 2,
  },

  smallCheck: {
    backgroundColor: '#2989ff',
    borderRadius: '50%',
    color: '#ffffff',
    width: 20,
    height: 20,
    padding: 2,
    marginRight: 10,
  },
  smallX: {
    backgroundColor: '#e34242',
    borderRadius: '50%',
    color: '#ffffff',
    width: 20,
    height: 20,
    padding: 2,
    marginRight: 10,
  },
  smallLink: {
    backgroundColor: '#706e6b',
    borderRadius: '50%',
    color: '#ffffff',
    width: 20,
    height: 20,
    padding: 2,
    marginRight: 10,
  },
  hideFocus: {
    backgroundColor: 'transparent !important',
  },
}));
